export const lineSeparator = '\r\n';